module.exports = __webpack_public_path__ + "static/media/safe-buy-logo.b79c6a1d.png";